// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3Z6Hf","savePackageButton":"ClientWallet_savePackageButton__PhW9o"};